const asset = require('./asset');
const makeTransformer = require('./make');
const modelTransformer = require('./model');
const articleTransformer = require('./article');
const isResolvedResource = require('../contentful/is-resolved-resource');

const createAssetLink = (asset) => {
  return {
    sys: {
      type: 'Link',
      linkType: 'Asset',
      id: asset.id
    }
  };
};

const createEntryLink = (entry) => {
  return {
    sys: {
      type: 'Link',
      linkType: 'Entry',
      id: entry.id
    }
  };
};

module.exports = {
  contentfulToInternal(entry) {
    const result = {
      id: entry.sys.id,
      published: Boolean(entry.sys.publishedVersion),
      updated: entry.sys.publishedVersion && entry.sys.version > entry.sys.publishedVersion + 1,
      draft: !entry.sys.publishedVersion,
      archived: Boolean(entry.sys.archivedVersion),
      contentType: null,
      model: null,
      make: null,
      modelId: null,
      makeId: null,
      startYear: null,
      endYear: null,
      modelGroup: ((entry.fields.modelGroup && entry.fields.modelGroup['nb-NO']) ? entry.fields.modelGroup['nb-NO'] : ''),
      name: ((entry.fields.name && entry.fields.name['nb-NO']) ? entry.fields.name['nb-NO'] : ''),
      listImage: null,
      files: [],
      articles: []
    };

    if (entry.sys && entry.sys.contentType) {
      result.contentType = entry.sys.contentType.sys.id;
    }


    // Make
    if (entry.fields.make && entry.fields.make['nb-NO']) {
      result.makeId = entry.fields.make['nb-NO'].sys.id;

      if (isResolvedResource(entry.fields.make['nb-NO'])) {
        result.make = makeTransformer.contentfulToInternal(entry.fields.make['nb-NO']);
      }
    }

    // Articles
    if (entry.fields.articles && entry.fields.articles['nb-NO']) {
      result.articles = entry.fields.articles['nb-NO'].filter(
        (resource) => isResolvedResource(resource)
      ).map(articleTransformer.contentfulToInternal);
    }

    // Model
    if (entry.fields.model && entry.fields.model['nb-NO']) {
      result.modelId = entry.fields.model['nb-NO'].sys.id;

      if (isResolvedResource(entry.fields.model['nb-NO'])) {
        result.model = modelTransformer.contentfulToInternal(entry.fields.model['nb-NO']);
      }
    }

    if (entry.fields.startYear && entry.fields.startYear['nb-NO']) {
      result.startYear = entry.fields.startYear['nb-NO'];
    }

    if (entry.fields.endYear && entry.fields.endYear['nb-NO']) {
      result.endYear = entry.fields.endYear['nb-NO'];
      // Hide endyear if it is set to max/inf (3000)
      if (result.endYear === 3000) {
        result.endYear = null;
      }
    }

    if (entry.fields.name && entry.fields.name['nb-NO']) {
      result.name = entry.fields.name['nb-NO'];
    }

    // Handle images:
    if (entry.fields.listImage && entry.fields.listImage['nb-NO'] && isResolvedResource(entry.fields.listImage['nb-NO'])) {
      result.listImage = asset.contentfulToInternal(entry.fields.listImage['nb-NO']);
    }

    // handle files
    if (entry.fields.files && entry.fields.files['nb-NO']) {
      result.files = entry.fields.files['nb-NO'].filter(
        (resource) => isResolvedResource(resource)
      ).map(
        asset.contentfulToInternal
      );
    }

    return result;
  },

  internalToContentful(generation) {
    const result = {
      fields: {
      }
    };

    result.fields.name = {
      'nb-NO': generation.name
    };

    if (typeof generation.startYear !== 'undefined') {
      result.fields.startYear = {
        'nb-NO': parseInt(generation.startYear, 10)
      };
    }

    if (typeof generation.endYear !== 'undefined') {
      result.fields.endYear = {
        'nb-NO': parseInt(generation.endYear, 10)
      };
    }
    if (!result.fields.endYear['nb-NO']) {
      // Set 3000 as endyear if not specified
      result.fields.endYear['nb-NO'] = 3000;
    }

    if (typeof generation.files !== 'undefined') {
      result.fields.files = {
        'nb-NO': generation.files ? generation.files.map(createAssetLink) : null
      };
    }

    if (typeof generation.listImage !== 'undefined') {
      result.fields.listImage = {
        'nb-NO': createAssetLink(generation.listImage)
      };
    }

    if (typeof generation.make !== 'undefined') {
      result.fields.make = {
        'nb-NO': createEntryLink(generation.make)
      };
    }

    if (typeof generation.model !== 'undefined') {
      result.fields.model = {
        'nb-NO': createEntryLink(generation.model)
      };

      if (generation.model.modelGroup) {
        result.fields.modelGroup = {
          'nb-NO': generation.model.modelGroup.toLowerCase()
        };
      }
    }

    if (typeof generation.articles !== 'undefined') {
      result.fields.articles = {
        'nb-NO': generation.articles ? generation.articles.map(createEntryLink) : null
      };
    }

    return result;
  }
};
